import React from "react";

const Footer = () => {
  return (
    <div className="flex justify-center items-center  w-full h-16 gap-2 ">
      <h1 className="text-gray-500 ">
        Designed & Built by Assegid Assegid ©️ 2023
      </h1>
      <svg
        class="feather feather-star w-6 h-6 text-green-300 hover:text-accent hover:scale-105 transition-all duration-200 !w-4 !h-4"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <title>Star</title>
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
      </svg>
      <spa className="text-green-300">4089</spa>
    </div>
  );
};

export default Footer;
